"use strict";
/*
 * © 2025 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleValidator = exports.availableLocales = void 0;
// These options need to match those for the parser, at ../i18next-parser-config.js
const productionLocales = ["de", "en", "zh", "it", "es", "ja", "pl"];
exports.availableLocales = ((_b = (_a = globalThis.process) === null || _a === void 0 ? void 0 : _a.env) === null || _b === void 0 ? void 0 : _b.NODE_ENV) === "production"
    ? productionLocales
    : [...productionLocales, "xx"];
exports.LocaleValidator = {
    type: "languageDetector",
    detect: () => {
        // Check querystring first
        const params = new URLSearchParams(window.location.search);
        const queryLng = params.get("lng");
        if (queryLng && exports.availableLocales.includes(queryLng)) {
            return queryLng;
        }
        // Check localStorage
        const storedLng = localStorage.getItem("i18nextLng");
        if (storedLng) {
            // Check if exact match
            if (exports.availableLocales.includes(storedLng)) {
                return storedLng;
            }
            // Check if base language is supported
            const baseLng = storedLng.toLowerCase().split("-")[0];
            if (exports.availableLocales.includes(baseLng)) {
                return storedLng;
            }
        }
        // Check browser language
        const browserLng = navigator.language || navigator.userLanguage;
        if (browserLng) {
            const lng = browserLng.toLowerCase();
            if (exports.availableLocales.includes(lng)) {
                return lng;
            }
            const baseLng = lng.split("-")[0];
            if (exports.availableLocales.includes(baseLng)) {
                return baseLng;
            }
        }
        // Check HTML tag
        const htmlLng = document.documentElement.lang;
        if (htmlLng && exports.availableLocales.includes(htmlLng)) {
            return htmlLng;
        }
        return "en";
    },
    cacheUserLanguage: (lng) => {
        localStorage.setItem("i18nextLng", lng);
    },
};
//# sourceMappingURL=index.js.map